<template>
  <div id="outer_game_list_outer" class="container" v-if="matchList != null">
    <div v-if="matchList.length > 0" >
      <a v-for="(item, index) in matchList"
         :key="'game-item-' + index"
         href="javascript:void(null);"
         @click="gameItemClicked(index)" >
        <game-item-card v-bind:item="item"></game-item-card>
      </a>
    </div>
    <div v-else style="height: 200px;color: #333;display: flex;flex-direction: column;align-items: center;justify-content: center;">
      <span>暂无相关信息</span>
    </div>
  </div>
</template>

<script>
  import GameHttpManager from '../../js/outer-games-http-define';
  import GameItemCard from "./GameItemCard";
export default {
  name: "OuterGamesList",
  components: {GameItemCard},
  data() {
    return {
      gameList: null,
      scheduleList: null,

      matchList: null,
    }
  },

  mounted() {
    this.loadScheduleData();
    this.loadGamesListData();
  },

  methods: {

    gameItemClicked(index) {
      let item = this.matchList[index];
      let id = item.id;
      let l = this.$router.resolve({
        name: 'matchGamesHomePage',
        params: {
          id: this.$route.params.id
        },
        query: {
          index: 1,
          sub: 1,
          id: id,
        }
      });
      // this.$router.go(0);
      window.open(l.href, '_self');

    },

    loadScheduleData() {
      let _this = this;
      GameHttpManager.getSchedulesList(function (data) {
        let status = data.status;
        if (status == 'success') {
          let list = data.data;
          _this.scheduleList = list;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
      });
    },

    loadGamesListData() {
      let _this = this;
      GameHttpManager.getGamesList(function (data) {
        let status = data.status;
        if (status == 'success') {
          let list = data.data;
          _this.gameList = list;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
      });
    },

    dealWithDataLoadSuccess() {
      let scheduleList = this.scheduleList;
      let gameList = this.gameList;
      if (scheduleList == null || gameList == null) {
        return;
      }

      let temp = [];
      for (let i = 0; i < scheduleList.length; i ++) {
        let scheduleItem = scheduleList[i];

        // scheduleItem.home_team_score = 11;
        // scheduleItem.away_team_score = 22;

        for (let j = 0; j < gameList.length; j++) {
          let gameItem = gameList[j];
          if (gameItem.id == scheduleItem.id) { // 此处待处理
            scheduleItem.home_team_score = gameItem.home_team_score;
            scheduleItem.away_team_score = gameItem.away_team_score;
            scheduleItem.started_at = gameItem.started_at;
            console.log(scheduleItem.started_at);
            scheduleItem.ended_at = gameItem.ended_at;
            gameList.slice(j, 1);
            break;
          }
        }
        temp.push(scheduleItem);
      }
      this.matchList = temp;
      this.gameList = null;
      this.scheduleList = null;
    }
  }
}
</script>

<style scoped>

  #outer_game_list_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
  }

  #outer_game_list_outer > div:first-child {
    width: 100%;
    margin-left: -13px;
    margin-top: -15px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  #outer_game_list_outer > div a {
    margin-left: 15px;
    margin-top: 15px;
    text-decoration: none;
    display: block;
  }

  @media screen and (min-width: 768px) {
    #outer_game_list_outer {
      padding: 40px 30px;
    }

    #outer_game_list_outer > div {
      justify-content: space-around;
    }
  }

  @media screen and (min-width: 1200px) {
    #outer_game_list_outer > div {
      justify-content: flex-start;
    }

    #outer_game_list_outer > div a {
      /*padding-left: 16px;*/
      /*padding-right: 16px;*/
      margin-left: 17px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/OuterGamesList.vue